import { type ReactElement } from 'react'
import { Group, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'

/** Confirms who the dashboard reaches before it is created. */
export function DashboardAudienceSummary({ summary }: { summary: string }): ReactElement {
  const { t } = useTranslation()

  return (
    <Group className='border-default-border p-2xl rounded-xl border' gap='xs' wrap='nowrap'>
      <MaterialSymbolIcon icon='visibility' size='md' />
      <Text size='sm'>{t('This dashboard will go to {{audience}}.', { audience: summary })}</Text>
    </Group>
  )
}
